import { Form, FormikProvider, useFormik } from 'formik';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Box, Flex } from 'reflexbox';

import { useErrorBoundary } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Button, GraphQLErrorMessage, Heading, Heading3 } from '@treams/treams-ui';

import DetailsTableForm from '../../packages/kakapo-ui-kit/components/common/DetailsTableForm/DetailsTableForm';
import { DetailsTableFormValueTypes } from '../../packages/kakapo-ui-kit/components/common/DetailsTableForm/DetailsTableFormValue';

function SettingsCreateNewTeam(): ReactElement {
	const { t } = useTranslation();
	const history = useHistory();

	const formik = useFormik({
		initialValues: {
			name: '',
		},
		onSubmit: () => {},
	});

	const [error, attempt, reset] = useErrorBoundary();

	const [create, { loading }] = graphql.useCreateGroupMutation();

	const onCreate = attempt(async () => {
		reset();

		const { data } = await create({
			variables: {
				input: {
					name: formik.values.name,
					type: graphql.GroupType.Team,
				},
			},
		});

		history.push(`/settings/organization/teams/${data!.createGroup.group.id}`);
	});

	return (
		<Flex flexDirection="column">
			<Flex flexDirection="row" alignItems="center">
				<Heading>{t('common.settings.teams.create.title')}</Heading>

				<Box ml={3}>
					<Heading3 mb={0}>{t('common.status.Draft')}</Heading3>
				</Box>
			</Flex>
			<Flex mt={4}>
				<Heading3>{t('common.settings.teams.create.details')}</Heading3>
			</Flex>
			<GraphQLErrorMessage error={error} />
			<FormikProvider value={formik}>
				<Form>
					<DetailsTableForm
						formValues={[
							{
								label: 'Name',
								name: 'name',
								type: DetailsTableFormValueTypes.Text,
							},
						]}
					/>
				</Form>
			</FormikProvider>

			<Flex mt={3}>
				<Button onClick={onCreate} loading={loading} title={t('common.save')} />
			</Flex>
		</Flex>
	);
}

export default SettingsCreateNewTeam;
